import { useList } from '../../../api/react-query';

export function useSuggetions({ params }) {
  const { data, isLoading, refetch } = useList(
    'config/suggestedTypes',
    { ...params },
    '',
    'v1',
  );
  return {
    data: data?.data?.data,
    isLoading,
    suggetionCount: data?.data?.total || data?.data?.data?.length,
    refetch,
  };
}
